export const SET_AWARD_VALUE = 'setState_SET_AWARD_VALUE';
export const SET_ALLOCATE_POINTS = 'setState_SET_ALLOCATE_POINTS';